import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getAdminSystemInoperabilityList = (state: IRootState) => state.admin.systemInoperabilityList;
export const getAdminSystemInoperabilityTotalCount = (state: IRootState) =>
  state.admin.systemInoperabilityListTotalCount;
export const getAdminSystemInoperabilityListPage = (state: IRootState) => state.admin.systemInoperabilityListPage;
